import transformToCamelCase from '@/api/shared/transformers/toCamelCaseTransformer';

export default function transformCampaignOverallStats({ campaigns, stats }) {
  const { impressions, views, installs, cost, avg_cost } = stats;

  return campaigns.reduce((uuidToStatsMap, campaign) => {
    uuidToStatsMap[campaign.uuid] = {
      impressions: impressions.campaigns_data[campaign.uuid],
      views: views.campaigns_data[campaign.uuid],
      installs: installs.campaigns_data[campaign.uuid],
      cost: cost.campaigns_data[campaign.uuid],
      avgCost: avg_cost.campaigns_data[campaign.uuid],
    };
    return uuidToStatsMap;
  }, {});
}
